/* Crealis UX — progressive enhancement; native forms remain authoritative. */
(() => {
  if (window.__crealisUX) return;
  window.__crealisUX = true;
  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-cr-rewards]')) {
      document.querySelector('header-drawer .menu-drawer__close-button')?.click();
    }
  });

  function initBuybar() {
    const bar = document.querySelector('[data-cr-buybar]');
    if (!bar || bar.dataset.ready) return;
    bar.dataset.ready = 'true';
    const section = document.getElementById('shopify-section-' + bar.dataset.section);
    if (!section) return;
    let variants;
    try { variants = JSON.parse(bar.querySelector('[data-cr-buybar-variants]').textContent); } catch { return; }
    const button = bar.querySelector('[data-cr-buybar-submit]');
    const price = bar.querySelector('[data-cr-buybar-price]');
    const label = bar.querySelector('[data-cr-buybar-label]');
    const currency = bar.dataset.currency || 'CLP';
    const formatter = new Intl.NumberFormat('es-CL', {style:'currency',currency,maximumFractionDigits:currency === 'CLP' ? 0 : 2});
    const getForm = () => section.querySelector('form[data-type="add-to-cart-form"]');
    const getSubmit = () => getForm()?.querySelector('button[type="submit"]');
    const mobile = matchMedia('(max-width: 749px)');
    const setText = (element, value) => { if (element.textContent !== value) element.textContent = value; };
    let scheduled = false;
    function sync() {
      scheduled = false;
      const form = getForm();
      const nativeButton = getSubmit();
      if (!form || !nativeButton) { bar.hidden = true; return; }
      const id = form.querySelector('[name="id"]')?.value;
      const variant = variants.find(v => String(v.id) === id);
      const qtyInput = form.querySelector('[name="quantity"]');
      const qty = Math.max(1, Number(qtyInput?.value) || 1);
      const selectedPack = section.querySelector('[data-cr-pack][aria-pressed="true"]');
      const discount = selectedPack && Number(selectedPack.dataset.crPack) === qty ? Number(selectedPack.dataset.crPackPct) || 0 : 0;
      if (variant) setText(price, formatter.format(Math.floor(variant.price * qty * (100 - discount) / 100) / 100));
      setText(label, qty + (qty === 1 ? ' unidad' : ' unidades') + (discount ? ' · total estimado' : ''));
      const incomplete = nativeButton.disabled && !!variant?.available;
      const disabled = !variant?.available || nativeButton.getAttribute('aria-busy') === 'true';
      if (button.disabled !== disabled) button.disabled = disabled;
      setText(button, !variant?.available ? 'No disponible' : incomplete ? 'Completar selección' : 'Agregar al carrito');
      const bounds = nativeButton.getBoundingClientRect();
      const buttonVisible = bounds.bottom > 80 && bounds.top < innerHeight - 76;
      const typing = /^(INPUT|TEXTAREA|SELECT)$/.test(document.activeElement?.tagName);
      const overlay = document.querySelector('dialog[open], .menu-drawer-container[open]');
      bar.hidden = !mobile.matches || buttonVisible || !!overlay || typing;
      document.body.classList.toggle('cr-buybar-visible', !bar.hidden);
    }
    function schedule() { if (!scheduled) { scheduled = true; requestAnimationFrame(sync); } }
    button.addEventListener('click', () => {
      const nativeButton = getSubmit();
      if (!nativeButton) return;
      if (nativeButton.disabled) {
        const target = section.querySelector('#cr-pack-custom, [data-cr-selector-diseno], .cr-dis, variant-picker') || nativeButton;
        target.scrollIntoView({behavior:reducedMotion.matches?'instant':'smooth',block:'center'});
        return;
      }
      const form = getForm();
      if (form && !form.reportValidity()) return;
      nativeButton.click();
      schedule();
    });
    new MutationObserver(schedule).observe(section,{childList:true,subtree:true,attributes:true,attributeFilter:['disabled','value','aria-pressed','aria-busy']});
    new MutationObserver(schedule).observe(document.body,{subtree:true,attributes:true,attributeFilter:['open']});
    ['input','change','variant:update','cart:update','cart:error','focusin','focusout'].forEach(type => document.addEventListener(type,schedule));
    addEventListener('scroll',schedule,{passive:true});
    addEventListener('resize',schedule,{passive:true});
    mobile.addEventListener('change',schedule);
    sync();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',initBuybar); else initBuybar();
  document.addEventListener('shopify:section:load',initBuybar);
})();
